export const CHARGER_STATUS = {
  ONLINE: "online",
  OFFLINE: "offline",
  CHARGING: "charging",
  FAULTED: "faulted",
  PREPARING: "preparing",
};

export const STATUS_COLORS = {
  [CHARGER_STATUS.ONLINE]: "#10b981",
  [CHARGER_STATUS.OFFLINE]: "#6b7280",
  [CHARGER_STATUS.CHARGING]: "#2563eb",
  [CHARGER_STATUS.FAULTED]: "#ef4444",
  [CHARGER_STATUS.PREPARING]: "#f59e0b",
};

export const STATUS_LABELS = {
  [CHARGER_STATUS.ONLINE]: "Available",
  [CHARGER_STATUS.OFFLINE]: "Offline",
  [CHARGER_STATUS.CHARGING]: "Charging",
  [CHARGER_STATUS.FAULTED]: "Faulted",
  [CHARGER_STATUS.PREPARING]: "Preparing",
};

export const CHART_TITLE = "Charger Status";
export const TOOLTIP_BORDER = "1px solid #e5e7eb";

export const MOCK_STATUS_BREAKDOWN = [
  { status: CHARGER_STATUS.CHARGING, count: 42 },
  { status: CHARGER_STATUS.ONLINE, count: 35 },
  { status: CHARGER_STATUS.PREPARING, count: 20 },
  { status: CHARGER_STATUS.OFFLINE, count: 21 },
  { status: CHARGER_STATUS.FAULTED, count: 10 },
];
